module.exports = __webpack_public_path__ + "static/media/translados.82252c74.svg";